// @ts-ignore no type declarations found
import { handleActions } from 'flux-actions';
import * as ActionTypes from 'MeetingsLib/redux/actions/ActionTypes';
const initialState = new Set();
export default handleActions({
  [ActionTypes.ADD_GUEST_EMAIL](state, action) {
    if (state.has(action.payload)) {
      return state;
    }
    return new Set(state).add(action.payload);
  },
  [ActionTypes.REMOVE_GUEST_EMAIL](state, action) {
    const email = action.payload;
    if (state.has(email)) {
      const nextState = new Set(state);
      nextState.delete(email);
      return nextState;
    }
    return state;
  }
}, initialState);